<template>
    <div>
        <div class="app-title">
            <em-view-title :crudState="$_emCommonListMixin_pathType"></em-view-title>
        </div>
        <section class="app-content" v-menu-permission="'list'">
            <div id="accordionFilter" class="content">
                <div class="card">
                    <div id="collapseOne" class="collapse show" aria-labelledby="headingOne"
                         data-parent="#accordionFilter">
                        <div class="card-body">
                            <form>
                                <em-filter :entity="modelName" ref="emListFilter"
                                           @showEntityModalSelect="$_emCommonModalMixin_showModalSelectorByFilter"></em-filter>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
            <div id="sithMesQualityToolCheckResultResultTable" class="content">
                <div class="card my-1">
                    <div id="collapseTwo" class="collapse show" aria-labelledby="headingTwo"
                         data-parent="#accordionResult">
                        <div class="card-body">
                            <em-table :entity="modelName" withCustomRowActions
                                      ref="emTable" exportDisabled :inlineActionsDisabled="prop_inline!=='1'"
                                      @showModalSelectorByNewRow="$_emCommonModalMixin_showModalSelectorByNewRow"
                                      @showModalSelectorByEditRow="$_emCommonModalMixin_showModalSelectorByEditRow">
                                <template slot="customRowActions" slot-scope="customRowScope">
                                  <b-button-group>
                                    <em-button type="edit" custom-icon="fa fa-arrow-down"
                                         custom-label="下载检定报告"
                                         v-menu-permission="'edit'"
                                         v-bind:class="'btn btn-outline-primary btn-sm'"
                                         @click="downloadPdf(customRowScope.row)"
                                    ></em-button>
                                  </b-button-group>
                                </template>
                            </em-table>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <em-modal-entity-selector ref="emModalEntitySelector"></em-modal-entity-selector>
    </div>
</template>
<script>
    // Author Shi Wenlong
    // Date 2021-06-07 14:32:06

    import emCommonListMixin from "@/mixin/em/common/list";
    import emApiMixin from "@/mixin/em/common/api";

    export default {
        name: "sithMesQualityToolCheckResultListView",
        mixins: [emCommonListMixin,emApiMixin],
        props:{
            //是否启用行编辑
            prop_inline: {
                type: String,
                default: "0"
            }
        },
        computed:{
            modelName(){
                return this.$_emRouterHelperMixin_entityName;
            },
            entityBaseUrl() {
                return `${this.$_emApiMixin_entityBaseApi('sithMesQualityToolCheckResult')}/`
            },
        },
        methods:{
            downloadPdf(row) {
                let url = this.entityBaseUrl + 'downloadFile';
                let data = new window.FormData();
                data.append("fileName",row.uploadPath);
                this.$store.dispatch("api/postReportDownload", {
                    url: url,
                    data: data
                }, {root: true})
                .then(res => {
                      console.log(res);
                      let blob = new Blob([res], {
                        type: `application/pdf;charset-UTF-8`
                      });
                      let objectURL = URL.createObjectURL(blob);
                      let downEle = document.createElement('a');
                      downEle.href = objectURL;
                      downEle.setAttribute('download', row.fileName);
                      document.body.appendChild(downEle);
                      downEle.click();
                })
            }
        },
        mounted(){
            this.$refs["emListFilter"].doQuery();
        }
    };
</script>